/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { updateMenuDeltaRequestSchema } from "./updateMenuDeltaRequestSchema.ts";
import { updateMenuDeltaSchema } from "./updateMenuDeltaSchema.ts";

export const callbackPluginUpdateMenuDeltaCreateStatus200Schema = updateMenuDeltaSchema;

export const callbackPluginUpdateMenuDeltaCreateResponseSchema = callbackPluginUpdateMenuDeltaCreateStatus200Schema;

export const callbackPluginUpdateMenuDeltaCreateDataSchemaJson = updateMenuDeltaRequestSchema;

export const callbackPluginUpdateMenuDeltaCreateDataSchemaXml = updateMenuDeltaRequestSchema;

export const callbackPluginUpdateMenuDeltaCreateDataSchema = z.union([
	callbackPluginUpdateMenuDeltaCreateDataSchemaJson,
	callbackPluginUpdateMenuDeltaCreateDataSchemaXml,
]);
